/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrateColor } from './CrateColor';
import {
    CrateColorFromJSON,
    CrateColorFromJSONTyped,
    CrateColorToJSON,
    CrateColorToJSONTyped,
} from './CrateColor';
import type { LootBoxPlacementContext } from './LootBoxPlacementContext';
import {
    LootBoxPlacementContextFromJSON,
    LootBoxPlacementContextFromJSONTyped,
    LootBoxPlacementContextToJSON,
    LootBoxPlacementContextToJSONTyped,
} from './LootBoxPlacementContext';
import type { LootBoxPrize } from './LootBoxPrize';
import {
    LootBoxPrizeFromJSON,
    LootBoxPrizeFromJSONTyped,
    LootBoxPrizeToJSON,
    LootBoxPrizeToJSONTyped,
} from './LootBoxPrize';
import type { LootBoxCycleType } from './LootBoxCycleType';
import {
    LootBoxCycleTypeFromJSON,
    LootBoxCycleTypeFromJSONTyped,
    LootBoxCycleTypeToJSON,
    LootBoxCycleTypeToJSONTyped,
} from './LootBoxCycleType';

/**
 * 
 * @export
 * @interface LootBoxConfigResponse
 */
export interface LootBoxConfigResponse {
    /**
     * 
     * @type {string}
     * @memberof LootBoxConfigResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof LootBoxConfigResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof LootBoxConfigResponse
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof LootBoxConfigResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LootBoxConfigResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof LootBoxConfigResponse
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof LootBoxConfigResponse
     */
    redemptionAnimation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LootBoxConfigResponse
     */
    transitionEffectEnabled: boolean;
    /**
     * 
     * @type {Array<LootBoxPrize>}
     * @memberof LootBoxConfigResponse
     */
    prizes: Array<LootBoxPrize>;
    /**
     * 
     * @type {LootBoxCycleType}
     * @memberof LootBoxConfigResponse
     */
    cycleType: LootBoxCycleType;
    /**
     * 
     * @type {Date}
     * @memberof LootBoxConfigResponse
     */
    refreshAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof LootBoxConfigResponse
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof LootBoxConfigResponse
     */
    endDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof LootBoxConfigResponse
     */
    maxOpensPerUser?: number;
    /**
     * 
     * @type {number}
     * @memberof LootBoxConfigResponse
     */
    maxOpensPerUserPerCycle?: number;
    /**
     * 
     * @type {number}
     * @memberof LootBoxConfigResponse
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof LootBoxConfigResponse
     */
    fuelPrice?: number;
    /**
     * Minimum quantity per purchase (LootShop stepper floor). Defaults to 1.
     * @type {number}
     * @memberof LootBoxConfigResponse
     */
    minPurchaseQuantity?: number;
    /**
     * 
     * @type {Array<LootBoxPlacementContext>}
     * @memberof LootBoxConfigResponse
     */
    placementContexts: Array<LootBoxPlacementContext>;
    /**
     * 
     * @type {number}
     * @memberof LootBoxConfigResponse
     */
    sortPriority: number;
    /**
     * 
     * @type {boolean}
     * @memberof LootBoxConfigResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LootBoxConfigResponse
     */
    onChain: boolean;
    /**
     * 
     * @type {string}
     * @memberof LootBoxConfigResponse
     */
    nftTracker?: string;
    /**
     * 
     * @type {CrateColor}
     * @memberof LootBoxConfigResponse
     */
    crateColor?: CrateColor;
    /**
     * The LootBoxPrizePoolVersion new instances are stamped to. `prizes` is the editable template; the version is the frozen pool actually drawn against.
     * @type {string}
     * @memberof LootBoxConfigResponse
     */
    currentPoolVersionId?: string;
    /**
     * Read-only. Remaining PURCHASABLE stock on the current pool version (totalQuantity − soldQuantity − reservedQuantity); distinct from remaining winnable prizes (Σ quantity − wonQuantity). Caps the LootShop purchase quantity. Populated only on the active-configs endpoint.
     * @type {number}
     * @memberof LootBoxConfigResponse
     */
    availableSupply?: number;
}



/**
 * Check if a given object implements the LootBoxConfigResponse interface.
 */
export function instanceOfLootBoxConfigResponse(value: object): value is LootBoxConfigResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('transitionEffectEnabled' in value) || value['transitionEffectEnabled'] === undefined) return false;
    if (!('prizes' in value) || value['prizes'] === undefined) return false;
    if (!('cycleType' in value) || value['cycleType'] === undefined) return false;
    if (!('placementContexts' in value) || value['placementContexts'] === undefined) return false;
    if (!('sortPriority' in value) || value['sortPriority'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('onChain' in value) || value['onChain'] === undefined) return false;
    return true;
}

export function LootBoxConfigResponseFromJSON(json: any): LootBoxConfigResponse {
    return LootBoxConfigResponseFromJSONTyped(json, false);
}

export function LootBoxConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootBoxConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'image': json['image'] == null ? undefined : json['image'],
        'redemptionAnimation': json['redemptionAnimation'] == null ? undefined : json['redemptionAnimation'],
        'transitionEffectEnabled': json['transitionEffectEnabled'],
        'prizes': ((json['prizes'] as Array<any>).map(LootBoxPrizeFromJSON)),
        'cycleType': LootBoxCycleTypeFromJSON(json['cycleType']),
        'refreshAt': json['refreshAt'] == null ? undefined : (new Date(json['refreshAt'])),
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'maxOpensPerUser': json['maxOpensPerUser'] == null ? undefined : json['maxOpensPerUser'],
        'maxOpensPerUserPerCycle': json['maxOpensPerUserPerCycle'] == null ? undefined : json['maxOpensPerUserPerCycle'],
        'price': json['price'] == null ? undefined : json['price'],
        'fuelPrice': json['fuelPrice'] == null ? undefined : json['fuelPrice'],
        'minPurchaseQuantity': json['minPurchaseQuantity'] == null ? undefined : json['minPurchaseQuantity'],
        'placementContexts': ((json['placementContexts'] as Array<any>).map(LootBoxPlacementContextFromJSON)),
        'sortPriority': json['sortPriority'],
        'isActive': json['isActive'],
        'onChain': json['onChain'],
        'nftTracker': json['nftTracker'] == null ? undefined : json['nftTracker'],
        'crateColor': json['crateColor'] == null ? undefined : CrateColorFromJSON(json['crateColor']),
        'currentPoolVersionId': json['currentPoolVersionId'] == null ? undefined : json['currentPoolVersionId'],
        'availableSupply': json['availableSupply'] == null ? undefined : json['availableSupply'],
    };
}

export function LootBoxConfigResponseToJSON(json: any): LootBoxConfigResponse {
    return LootBoxConfigResponseToJSONTyped(json, false);
}

export function LootBoxConfigResponseToJSONTyped(value?: LootBoxConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'name': value['name'],
        'description': value['description'],
        'image': value['image'],
        'redemptionAnimation': value['redemptionAnimation'],
        'transitionEffectEnabled': value['transitionEffectEnabled'],
        'prizes': ((value['prizes'] as Array<any>).map(LootBoxPrizeToJSON)),
        'cycleType': LootBoxCycleTypeToJSON(value['cycleType']),
        'refreshAt': value['refreshAt'] == null ? undefined : ((value['refreshAt']).toISOString()),
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'maxOpensPerUser': value['maxOpensPerUser'],
        'maxOpensPerUserPerCycle': value['maxOpensPerUserPerCycle'],
        'price': value['price'],
        'fuelPrice': value['fuelPrice'],
        'minPurchaseQuantity': value['minPurchaseQuantity'],
        'placementContexts': ((value['placementContexts'] as Array<any>).map(LootBoxPlacementContextToJSON)),
        'sortPriority': value['sortPriority'],
        'isActive': value['isActive'],
        'onChain': value['onChain'],
        'nftTracker': value['nftTracker'],
        'crateColor': CrateColorToJSON(value['crateColor']),
        'currentPoolVersionId': value['currentPoolVersionId'],
        'availableSupply': value['availableSupply'],
    };
}

